import { DateTime } from 'luxon';

const DATE_FORMAT = 'MMM dd, yyyy';

/**
 * Formats date to a readable string format (e.g., "Jan 15, 2024")
 * @param date - Valid ISO string
 * @returns Formatted date string
 */
const getFormattedDate = (
  date: string,
  format: string = DATE_FORMAT,
): string => {
  const dateTime = DateTime.fromISO(date);
  return dateTime.toFormat(format);
};

export default getFormattedDate;
